import { I18nContext } from "@common/contexts/I18n";
import { type I18n } from "@common/lib/i18n";
import React from "react";

export const useI18n = (): I18n => {
  const context = React.useContext(I18nContext);

  return context.i18n;
};
